/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.a-range {
  appearance: none;
  width: 100%;
  min-height: 49px;
}
.a-range::-webkit-slider-runnable-track {
  height: 0.6875rem;
  width: 100%;
  background-color: var(--gray-80);
  border: 1px solid var(--gray-40);
  border-radius: 8px;
  cursor: pointer;
}
.a-range::-moz-range-track {
  height: 0.6875rem;
  width: 100%;
  background-color: var(--gray-80);
  border: 1px solid var(--gray-40);
  border-radius: 8px;
  cursor: pointer;
}
.a-range::-webkit-slider-thumb {
  height: 2.8125rem;
  width: 2.8125rem;
  margin-top: -1.125rem;
  appearance: none;
  border: 1px solid var(--gray-40);
  border-radius: 50%;
  background-color: var(--gray-10);
  cursor: pointer;
}
.a-range::-moz-range-thumb {
  height: 2.8125rem;
  width: 2.8125rem;
  margin-top: -1.125rem;
  appearance: none;
  border: 1px solid var(--gray-40);
  border-radius: 50%;
  background-color: var(--gray-10);
  cursor: pointer;
}
.a-range:focus, .a-range.focus {
  box-shadow: none;
  outline: none;
}
.a-range:focus::-webkit-slider-thumb, .a-range.focus::-webkit-slider-thumb {
  background-color: var(--pacific-20);
  border: 2px solid var(--pacific);
}
.a-range:focus::-moz-range-thumb, .a-range.focus::-moz-range-thumb {
  background-color: var(--pacific-20);
  border: 2px solid var(--pacific);
}